import React from "react";

import "./Button.css";
import classNames from "classnames";

const button = props => (
    <button
        disabled={props.disabled}
        className={classNames({
            "Button Success": props.btnType === "Success",
            "Button Danger": props.btnType === "Danger"
        })}
        onClick={props.clicked}
    >
        {props.children}
    </button>
);

export default button;
